import React from 'react';
import { Tag } from 'antd';

/** 每页条数可选项：上限须与后端 TmsLoadingArchiveOpsService.MAX_PAGE_SIZE（100）一致，超过会被后端静默截断导致条数对不上 */
export const ARCHIVE_PAGE_SIZE_OPTIONS = ['20', '50', '100'];

/** 归档情况，对齐后端 TmsLoadingArchiveStatus：1-未归档 2-已归档 3-无装车数据 4-异常（热表与归档表均有数据） */
export const ARCHIVE_STATUS = { NOT_ARCHIVED: 1, ARCHIVED: 2, NO_DATA: 3, INCONSISTENT: 4 } as const;

const ARCHIVE_STATUS_MAP: Record<number, { label: string; color: string }> = {
    [ARCHIVE_STATUS.NOT_ARCHIVED]: { label: '未归档', color: 'blue' },
    [ARCHIVE_STATUS.ARCHIVED]: { label: '已归档', color: 'green' },
    [ARCHIVE_STATUS.NO_DATA]: { label: '无装车数据', color: 'default' },
    [ARCHIVE_STATUS.INCONSISTENT]: { label: '异常', color: 'red' },
};

export const renderArchiveStatus = (value: number | null): React.ReactNode => {
    if (value === null || value === undefined) return '-';
    const item = ARCHIVE_STATUS_MAP[value];
    return item ? <Tag color={item.color}>{item.label}</Tag> : <Tag>{value}</Tag>;
};

/** 查看装车包牌的数据来源：1-在线表 2-归档表 */
export const renderDataSource = (value: number | null | undefined): React.ReactNode => {
    if (value === 1) return <Tag color="blue">在线表（未归档）</Tag>;
    if (value === 2) return <Tag color="green">归档表（已归档）</Tag>;
    return null;
};

/** 事件状态：空-不需要 0-待写入 1-已写入 */
export const renderEventStatus = (value: number | null): React.ReactNode => {
    if (value === null || value === undefined) return '-';
    if (value === 0) return <Tag color="orange">待写入</Tag>;
    if (value === 1) return <Tag color="green">已写入</Tag>;
    return <Tag>{value}</Tag>;
};
